<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'
import { useSkeleton } from '@/modules/core/composables/useSkeleton'
import TheFileSystem from '../../components/TheFileSystem.vue'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import WorkspaceNav from '@/modules/workspace/components/workspace-nav.vue'
import { RouterLinkBack } from '@/modules/shared/components'
import VButtonInvisible from '@/modules/shared/components/v-button-invisible.vue'
import { useInvestingInvestorStore } from '@/modules/investing/stores/investor-store'
import { useFilingStore } from '../../stores/filing-store'

const workspaceStore = useWorkspaceStore()
const filingStore = useFilingStore()
const theFileSystem = ref(null)
const workspace = computed(() => workspaceStore.current)
const investorStore = useInvestingInvestorStore()
const rootFolder = computed(() =>
  filingStore.folders.find((folder) => folder.id === workspace.value?.filing_folder_root_id),
)

const { skeleton, hideSkeleton, showSkeleton } = useSkeleton()

const shareholders = computed(() =>
  investorStore.investors.map((investor) => ({
    id: investor.id,
    name: investor.name,
    type: ['fund', 'fundingentity'].includes(investor.type) ? 'InvestorSet' : 'Investor',
  })),
)

onMounted(async () => {
  showSkeleton()
  await filingStore.resetStore()
  await workspaceStore.fetchCurrent()
  await filingStore.fetchFolder(workspace.value.filing_folder_root_id)
  await Promise.all([investorStore.fetchInvestors(), theFileSystem.value?.fetchAll()])
  hideSkeleton()
})
</script>

<template>
  <TheLayout>
    <div class="-mt-8 mb-6">
      <RouterLinkBack class="text-lg" :to="{ name: 'dashboard' }">
        <VButtonInvisible>← Back</VButtonInvisible>
      </RouterLinkBack>
    </div>

    <WorkspaceNav />

    <div class="mx-auto">
      <TheFileSystem ref="theFileSystem" :skeleton="skeleton" :rootFolder="rootFolder" :shareholders="shareholders" />
    </div>
  </TheLayout>
</template>
